import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import axios from 'axios';

const Footer = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    // Replace the URL with your backend API endpoint to fetch categories
    axios.get('https://www.hum.ujn.mybluehostin.me/new_clinet/snkb_api/category.php')
      .then(response => {
        setCategories(response.data);
      })
      .catch(error => {
        console.error('Error fetching categories:', error);
      });
  }, []);

  return (
    <footer className="main-footer">
      <div className="auto-container">
        <div className="footer-top">
          <div className="row align-items-center">
            <div className="col-lg-4 col-md-6 col-sm-12 logo-column">
              <figure className="footer-logo">
                 <Link  to="/">
                  <img src="/assets/images/snkb-logo.png" style={{ width: '187px', height: '100px', filter: 'brightness(0) invert(1)', paddingTop: '5px', paddingBottom: '5px' }} alt="SNKB Logo" />
                 </Link>
              </figure>
            </div>
            <div className="col-lg-8 col-md-6 col-sm-12 form-column">
              <div className="subscribe-form" style={{ textAlign: 'end' }}>
                <h3 style={{ color: 'white', borderBottom: '#d21a05' }}>High Precision High Quality We believe in precision</h3>
              </div>
            </div>
          </div>
        </div>
        <div className="widget-section">
          <div className="row clearfix">
            <div className="col-lg-4 col-md-6 col-sm-12 footer-column">
              <div className="footer-widget contact-widget">
                <div className="widget-content">
                  <div className="info-box">
                    <div className="single-item">
                      <h3>
                        <span style={{ borderBottom: '2px solid #d21a05', paddingBottom: '8px' }}> Enquiry</span>
                      </h3>
                      <p style={{ paddingTop: '8px' }}>
                         <Link  to="tel:+919930400377">+91 99304 00377 </Link><br />
                         <Link  to="mailto:info@snkbbearing.com">info@snkbbearing.com </Link>
                      </p>
                    </div>
                    <div className="single-item">
                      <h3>
                        <span style={{ borderBottom: '2px solid #d21a05', paddingBottom: '8px' }}> Reach</span>
                      </h3>
                      <p style={{ paddingTop: '8px' }}>
                        <strong>India</strong><br />
                        109 Swastik Disa Corporate Park,<br />
                        LBS Rd, Nityanand Nagar,<br />
                        Ghatkopar West, Mumbai
                      </p>
                      <p style={{ paddingTop: '8px' }}>
                        <strong>Japan</strong><br />
                        2-11-13, Sagisu, Fukushima-ku, Osaka, Japan
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-12 footer-column">
              <div className="footer-widget links-widget">
                <div className="widget-title">
                  <h3>
                    <span style={{ borderBottom: '2px solid #d21a05', paddingBottom: '8px' }}> Category</span>
                  </h3>
                </div>
                <div className="widget-content">
                  <ul className="links-list clearfix">
                    {categories.map(category => (
                      <li key={category.id}>
                         <Link  to={`/Products?category=${category.id}&cname=${encodeURIComponent(category.name)}`}>
                          {category.name}
                         </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-12 footer-column">
              <div className="footer-widget links-widget">
                <div className="widget-title">
                  <h3>
                    <span style={{ borderBottom: '2px solid #d21a05', paddingBottom: '8px' }}> Useful Links</span>
                  </h3>
                </div>
                <div className="widget-content">
                  <ul className="links-list clearfix">
                    <li> <Link  to="/">Home </Link></li>
                    <li> <Link  to="/Our_Category">Category </Link></li>
                    <li> <Link  to="/About_Us">About Us </Link></li>
                    <li> <Link  to="/SNKB_History">History </Link></li>
                    <li> <Link  to="/Contact_Us">Contact Us </Link></li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-lg-2 col-md-6 col-sm-12 footer-column">
              <div className="footer-widget links-widget">
                <div className="widget-title">
                  <h3>
                    <span style={{ borderBottom: '2px solid #d21a05', paddingBottom: '8px' }}> Other Links</span>
                  </h3>
                </div>
                <div className="widget-content">
                  <ul className="links-list clearfix">
                    <li> <Link  to="/Privacy_Policy">Privacy Policy </Link></li>
                    <li> <Link  to="/Return_Policy">Return Policy </Link></li>
                    <li> <Link  to="/Cookies_Policy">Cookies Policy </Link></li>
                    <li> <Link  to="/Terms_And_Condition">Terms And Conditions </Link></li>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="auto-container">
          <div className="bottom-inner">
            <div className="copyright">
              <p>Copyright &copy; 2024  <Link  to="/">SNKB Bearings </Link></p>
            </div>
            <ul className="footer-nav clearfix">
              <li>Managed By  <Link  to="https://www.gurusoftware.in/">GURUSOFTWARE </Link></li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
